import { z } from "zod";

export const DecorationRaritySchema = z.enum(["common", "rare", "epic"]);
export type DecorationRarity = z.infer<typeof DecorationRaritySchema>;

export const DecorationSourceSchema = z.enum(["chest", "event", "shop", "scrip"]);

/** A placeable decoration: one shipped model, a footprint in base cells and its morale value (D70). */
export const DecorationDefSchema = z.object({
  id: z.string().regex(/^deco\./),
  name: z.object({ de: z.string(), en: z.string() }),
  /** The inventory item that is consumed on placement and returned on removal (the garden has none to consume: it is bought). */
  itemId: z.string().regex(/^itm\.deco_/),
  model: z.string().regex(/^prop\./),
  footprint: z.object({ w: z.number().int().min(1).max(3), h: z.number().int().min(1).max(3) }),
  morale: z.number().int().min(0).max(5),
  rarity: DecorationRaritySchema,
  source: z.array(DecorationSourceSchema).min(1),
});
export type DecorationDef = z.infer<typeof DecorationDefSchema>;
